import { render, staticRenderFns } from "./configuraciontickeadora.vue?vue&type=template&id=864c7ca6"
import script from "./configuraciontickeadora.vue?vue&type=script&lang=js"
export * from "./configuraciontickeadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports